<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">服务协议</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">服务协议</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p style="text-align:center">
                            <strong>
                                <span style="font-size: 21px">夜樱情趣商城服务协议</span>
                            </strong>
                        </p>
                        <p style="text-align:right">
                            <span>                                             </span>
                        </p>
                        <p><strong>提示条款</strong></p>
                        <p>
                            欢迎您与夜樱情趣商城（详见定义条款）共同签署本《夜樱情趣商城服务协议》（下称“本协议”）并使用夜樱情趣商城服务！
                        </p>
                        <p>
                            本协议为《夜樱情趣服务协议》修订版本，自本协议发布之日起，夜樱情趣商城各处所称“夜樱情趣服务协议”均指本协议。
                        </p>
                        <p>
                            各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。
                        </p>
                        <p>
                            <span>
                                 【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对协议有任何疑问，可向夜樱情趣商城客服咨询。
                            </span>
                        </p>
                        <p>
                            <span>
                                 【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与夜樱情趣达成一致，成为夜樱情趣商城“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。
                            </span>
                        </p>
                        <p><strong>一、定义</strong></p>
                        <p>
                            <span>
                                夜樱情趣商城：指包括夜樱情趣（域名为 qu.cn）等网站及客户端。
                            </span>
                        </p>
                        <p>
                            <span>
                                夜樱情趣：夜樱情趣商城经营者的单称或合称，包括鸿巨网络科技有限公司、祥航网络科技有限公司等。
                            </span>
                        </p>
                        <p>
                            <span>
                                夜樱情趣商城服务：夜樱情趣基于互联网，以包含夜樱情趣商城网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。
                            </span>
                            <br>
                        </p>
                        <p>
                            <span>
                                夜樱情趣商城规则：包括在所有夜樱情趣商城规则频道内已经发布及后续发布的全部规则、解读、公告等内容以及帮助中心内发布的各类规则、实施细则、产品流程说明、公告等。
                            </span>
                        </p>
                        <p>
                            <span>夜樱情趣商城包括但不限于qu.cn，qw.cc等网站及客户端。</span>
                        </p>
                        <p>
                            <strong><span>二、 协议范围</span></strong>
                        </p>
                        <p>
                            <strong>
                                <span>2.1 签约主体</span>
                            </strong>
                        </p>
                        <p>
                            <span>
                                【平等主体】本协议由您与夜樱情趣商城经营者共同缔结，本协议对您与夜樱情趣商城经营者均具有合同效力。
                            </span>
                            <br>
                        </p>
                        <p>
                            <span>
                                【主体信息】夜樱情趣商城经营者是指经营夜樱情趣商城的各法律主体，您可随时查看夜樱情趣商城各网站首页底部公示的证照信息以确定与您履约的夜樱情趣主体。本协议项下，夜樱情趣商城经营者可能根据夜樱情趣商城的业务调整而发生变更，变更后的夜樱情趣商城经营者与您共同履行本协议并向您提供服务，夜樱情趣商城经营者的变更不会影响您本协议项下的权益。夜樱情趣商城经营者还有可能因为提供新的夜樱情趣商城服务而新增，如您使用新增的夜樱情趣商城服务的，视为您同意新增的夜樱情趣商城经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。
                            </span>
                        </p>
                        <p><strong><span>2.2 补充协议</span></strong></p>
                        <p>
                            <span>
                                由于互联网高速发展，您与夜樱情趣签署的本协议列明的条款并不能完整罗列并覆盖您与夜樱情趣所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，夜樱情趣商城法律声明及隐私权政策、夜樱情趣商城规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用夜樱情趣商城服务，视为您同意上述补充协议。
                            </span>
                        </p>
                        <p>
                            <strong><span>三、 账户注册与使用</span></strong>
                        </p>
                        <p>
                            <strong><span>3.1 用户资格</span></strong>
                        </p>
                        <p>
                            <span>
                                您确认，在您开始注册程序使用夜樱情趣商城服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
                            </span>
                        </p>
                        <p>
                            <span>
                                此外，您还需确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用夜樱情趣商城服务，同时您理解违反前述要求可能会造成您无法正常注册及使用夜樱情趣商城服务。
                            </span>
                        </p>
                        <p><strong><span>3.2 账户说明</span></strong></p>
                        <p>
                            <span>
                                【账户获得】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得夜樱情趣商城账户并成为夜樱情趣商城用户。
                            </span>
                        </p>
                        <p>
                            <span>
                                夜樱情趣商城只允许每位用户使用一个夜樱情趣商城账户。如有证据证明或夜樱情趣根据夜樱情趣商城规则判断您存在不当注册或不当使用多个夜樱情趣商城账户的情形，夜樱情趣商城可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给夜樱情趣商城及相关方造成损失的，您还应承担赔偿责任。
                            </span>
                        </p>
                        <p>
                            <span>
                                【账户使用】您有权使用您设置或确认的夜樱情趣会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录夜樱情趣商城。
                            </span>
                        </p>
                        <p>
                            <span>
                                由于您的夜樱情趣商城账户关联您的个人信息及夜樱情趣商城商业信息，您的夜樱情趣商城账户仅限您本人使用。未经夜樱情趣商城同意，您直接或间接授权第三方使用您夜樱情趣商城账户或获取您账户项下信息的行为无效。如夜樱情趣根据夜樱情趣商城规则中约定的违约认定程序及标准判断您夜樱情趣商城账户的使用可能危及您的账户安全及/或夜樱情趣商城信息安全的，夜樱情趣商城可拒绝提供相应服务或终止本协议。
                            </span>
                        </p>
                        <p>
                            <span>
                                【账户转让】由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经夜樱情趣同意，并符合夜樱情趣商城规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则夜樱情趣商城有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。
                            </span>
                        </p>
                        <p><strong><span>3.3 注册信息管理</span></strong></p>
                        <p><strong><span>3.3.1 真实合法</span></strong></p>
                        <p>
                            <span>
                                【信息真实】在使用夜樱情趣商城服务时，您应当按夜樱情趣商城页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便夜樱情趣或其他用户与您联系。您了解并同意，您有义务保持您提供信息的真实性及有效性。
                            </span>
                        </p>
                        <p>
                            <span>
                                【会员名的合法性】您设置的夜樱情趣会员名不得违反国家法律法规及夜樱情趣商城相关规则关于会员名的管理规定，否则夜樱情趣可回收您的夜樱情趣会员名。夜樱情趣会员名的回收不影响您以邮箱、手机号码登录夜樱情趣商城并使用夜樱情趣商城服务。
                            </span>
                        </p>
                        <p><strong><span>3.3.2 更新维护</span></strong></p>
                        <p>
                            <span>
                                您应当及时更新您提供的信息，在法律有明确规定要求夜樱情趣作为平台服务提供者必须对部分用户的信息进行核实的情况下，夜樱情趣将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。
                            </span>
                        </p>
                        <p>
                            <span>
                                如夜樱情趣按您最后一次提供的信息与您联系未果、您未按夜樱情趣的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及夜樱情趣造成的全部损失与不利后果。夜樱情趣可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部夜樱情趣商城服务，夜樱情趣对此不承担责任。
                            </span>
                        </p>
                        <p><strong><span>3.4 账户安全规范</span></strong></p>
                        <p>
                            <span>
                                【账户安全保管义务】您的账户为您自行设置并由您保管，夜樱情趣任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开夜樱情趣商城。
                            </span>
                        </p>
                        <p>
                            <span>
                                账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，夜樱情趣并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
                            </span>
                        </p>
                        <p>
                            <span>
                                【账户行为责任自负】除夜樱情趣存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。
                            </span>
                        </p>
                        <p>
                            <span>
                                【日常维护须知】如发现任何未经授权使用您账户登录夜樱情趣商城或其他可能导致您账户遭窃、遗失的情况，建议您立即通知夜樱情趣。您理解夜樱情趣对您的任何请求采取行动均需要合理时间，且夜樱情趣应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除夜樱情趣存在法定过错外，夜樱情趣不承担责任。
                            </span>
                        </p>
                        <p><strong><span>四、 夜樱情趣商城服务及规范</span></strong></p>
                        <p>
                            <span>
                                【服务概况】您有权在夜樱情趣商城上享受商品及/或服务的浏览、收藏、购买与评价、交易争议处理、信息交流如问答及分享等服务。夜樱情趣提供的服务内容众多，具体您可登录夜樱情趣商城浏览。
                            </span>
                        </p>
                        <p><strong><span>4.1 商品及/或服务的浏览</span></strong></p>
                        <p>
                            <span>
                                在您浏览我们网站或客户端的过程中，夜樱情趣为您提供了信息分类、关键词检索、筛选等功能，以更好地匹配您的需求。您可以对您感兴趣的商品及/或服务进行收藏、添加至购物车。
                            </span>
                        </p>
                        <p><strong><span>4.2商品及/或服务的购买与评价</span></strong></p>
                        <p>
                            <span>
                                【商品及/或服务的购买】当您在夜樱情趣商城购买商品及/或服务时，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。
                            </span>
                        </p>
                        <p>
                            <span>
                                您的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施恶意购买、恶意维权等扰乱夜樱情趣商城正常交易秩序的行为。基于维护夜樱情趣商城交易秩序及交易安全的需要，夜樱情趣发现上述情形时可主动执行关闭相关交易订单等操作。
                            </span>
                        </p>
                        <p>
                            <span>
                                【评价】您有权在夜樱情趣商城提供的评价系统中对与您达成交易的其他用户商品及/或服务进行评价。您应当理解，您在夜樱情趣商城的评价信息是公开的，如您不愿意在评价信息中向公众披露您的身份信息，您有权选择通过匿名形式发表评价内容。
                            </span>
                        </p>
                        <p>
                            <span>
                                为确保评价内容能为消费者购物决策提供可靠的依据，反映商品及/或服务的真实情况，您的所有评价行为应遵守夜樱情趣商城规则的相关规定，评价内容应当合法、客观、真实，与交易的商品及/或服务具有关联性，且不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。夜樱情趣可按照夜樱情趣商城规则的相关规定对您实施上述行为所产生的评价信息采取必要处置措施。
                            </span>
                        </p>
                        <p><strong><span>4.3信息交流</span></strong></p>
                        <p>
                            <span>
                                为满足用户间分享购物心得等信息交流需求，您可通过夜樱情趣提供的晒单分享及其他信息发布功能公开发布信息及与其他用户互动，信息的形式包括文字、图片、视频、直播内容等，您须确保您所发布的所有信息均符合相关法律法规及本协议的要求。
                            </span>
                        </p>
                        <p><strong><span>4.4责任限制</span></strong></p>
                        <p>
                            <span>
                                【不可抗力及第三方原因】夜樱情趣依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，夜樱情趣并不承担相应的违约责任：
                            </span>
                        </p>
                        <p>
                            <span>
                                <span>
                                    （一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
                                </span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <span>
                                    （二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
                                </span>
                            </span>
                        </p>
                        <p>
                            <span>
                                <span>
                                    （三）在夜樱情趣已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
                                </span>
                            </span>
                        </p>
                        <p>
                            <span>
                                【海量信息】夜樱情趣仅向您提供夜樱情趣商城服务，您了解夜樱情趣商城上的信息系用户自行发布，且可能存在风险和瑕疵。夜樱情趣将通过依法建立相关检查监控制度尽可能保障您在夜樱情趣商城上的合法权益及良好体验。同时，鉴于夜樱情趣商城具备存在海量信息及信息网络环境下信息与实物相分离的特点，夜樱情趣无法逐一审查商品及/或服务的信息，无法逐一审查交易所涉及的商品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。
                            </span>
                        </p>
                        <p>
                            <span>
                                【调处决定】您理解并同意，在争议调处服务中，夜樱情趣商城的客服、大众评审员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，调处方对争议调处决定免责。
                            </span>
                        </p>
                        <p><strong><span>五、用户信息的保护及授权</span></strong></p>
                        <p><strong><span>5.1 个人信息的保护</span></strong></p>
                        <p>
                            <span>
                                夜樱情趣非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用夜樱情趣提供的服务时，您同意夜樱情趣按照在夜樱情趣商城上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。如夜樱情夜樱情趣站或客户端未设独立隐私权政策但使用了夜樱情趣商城账号登陆相应网站或客户端的，为保护您的隐私权，我们将参照适用夜樱情夜樱情趣隐私权政策的要求对您的个人信息进行收集、存储、使用、披露和保护。夜樱情趣希望通过隐私权政策向您清楚地介绍夜樱情趣对您个人信息的处理方式，因此夜樱情趣建议您完整地阅读隐私权政策（点击此处），以帮助您更好地保护您的隐私权。
                            </span>
                        </p>
                        <p><strong><span>5.2非个人信息的保证与授权</span></strong></p>
                        <p>
                            <span>
                                【信息的发布】您声明并保证，您对您所发布的信息拥有相应、合法的权利。否则，夜樱情趣可对您发布的信息依法或依本协议进行删除或屏蔽。
                            </span>
                        </p>
                        <p>
                            <span>
                                【禁止性信息】您应当确保您所发布的信息不包含以下内容：
                            </span>
                        </p>
                        <p>
                            <span>（一）违反国家法律法规禁止性规定的；</span>
                        </p>
                        <p>
                            <span>（二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</span>
                        </p>
                        <p>
                            <span>（三）欺诈、虚假、不准确或存在误导性的；</span>
                        </p>
                        <p>
                            <span>（四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</span>
                        </p>
                        <p>
                            <span>（五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</span>
                        </p>
                        <p>
                            <span>（六）存在可能破坏、篡改、删除、影响夜樱情趣商城任何系统正常运行或未经授权秘密获取夜樱情趣商城及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</span>
                        </p>
                        <p>
                            <span>（七）其他违背社会公共利益或公共道德或依据相关夜樱情趣商城协议、规则的规定不适合在夜樱情趣商城上发布的。</span>
                        </p>
                        <p>
                            <span>
                                【授权使用】对于您提供、发布及在使用夜樱情趣商城服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，均不会因上传、发布等行为发生知识产权、肖像权等权利的转移。除非我们另行说明，在法律允许的范围内，您免费授予夜樱情趣及其关联公司无地域限制的许可使用（包括存储、使用、复制、修订、编辑、发布、展示、翻译、分发上述信息或制作派生作品，以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内等）及可再许可第三方使用的权利，以及可以自身名义对第三方侵权行为取证及提起诉讼的权利。
                            </span>
                        </p>
                        <p><strong><span>六、 用户的违约及处理</span></strong></p>
                        <p><strong><span>6.1 违约认定</span></strong></p>
                        <p><span>发生如下情形之一的，视为您违约：</span></p>
                        <p>
                            <span>（一）使用夜樱情趣商城服务时违反有关法律法规规定的；</span>
                        </p>
                        <p>
                            <span>（二）违反本协议或本协议补充协议（即本协议第2.2条）约定的。</span>
                        </p>
                        <p>
                            <span>
                                为适应电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，夜樱情趣可在夜樱情趣商城规则中约定违约认定的程序和标准。如：夜樱情趣可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。
                            </span>
                        </p>
                        <p><strong><span>6.2 违约处理措施</span></strong></p>
                        <p>
                            <span>
                                【信息处理】您在夜樱情趣商城上发布的信息构成违约的，夜樱情趣可根据相应规则立即对相应信息进行删除、屏蔽处理。
                            </span>
                        </p>
                        <p>
                            <span>
                                【行为限制】您在夜樱情趣商城上实施的行为，或虽未在夜樱情趣商城上实施但对夜樱情趣商城及其用户产生影响的行为构成违约的，夜樱情趣可依据相应规则对您执行账户扣分、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，夜樱情趣可查封您的账户，终止向您提供服务。
                            </span>
                        </p>
                        <p>
                            <span>
                                【处理结果公示】夜樱情趣可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在夜樱情趣商城上予以公示。
                            </span>
                        </p>
                        <p><strong><span>6.3 赔偿责任</span></strong></p>
                        <p>
                            <span>
                                如您的行为使夜樱情趣及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿夜樱情趣及/或其关联公司的上述全部损失。
                            </span>
                        </p>
                        <p>
                            <span>
                                如您的行为使夜樱情趣及/或其关联公司遭受第三人主张权利，夜樱情趣及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。
                            </span>
                        </p>
                        <p><strong><span>6.4 特别约定</span></strong></p>
                        <p>
                            <span>
                                【商业贿赂】如您向夜樱情趣及/或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，夜樱情趣可立即终止与您的所有合作并向您收取违约金及/或赔偿金，该等金额以夜樱情趣因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。
                            </span>
                        </p>
                        <p>
                            <span>
                                【关联处理】如您因严重违约导致夜樱情趣终止本协议时，出于维护平台秩序及保护消费者权益的目的，夜樱情趣及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议第八条约定的方式通知您。
                            </span>
                        </p>
                        <p>
                            <span>
                                如夜樱情趣与您签署的其他协议及夜樱情趣及/或其关联公司与您签署的协议中明确约定了对您在本协议项下合作进行关联处理的情形，则夜樱情趣出于维护平台秩序的目的，可在收到指令时中止甚至终止协议，并以本协议第八条约定的方式通知您。
                            </span>
                        </p>
                        <p><strong><span>七、 协议的变更</span></strong></p>
                        <p>
                            <span>
                                夜樱情趣可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第八条约定的方式通知您。
                            </span>
                        </p>
                        <p>
                            <span>
                                如您不同意变更事项，您有权于变更事项确定的生效日前联系夜樱情趣反馈意见。如反馈意见得以采纳，夜樱情趣将酌情调整变更事项。
                            </span>
                        </p>
                        <p>
                            <span>
                                如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用夜樱情趣商城服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用夜樱情趣商城服务，则视为您同意已生效的变更事项。
                            </span>
                        </p>
                        <p><strong><span>八、 通知</span></strong></p>
                        <p><strong><span>8.1有效联系方式</span></strong></p>
                        <p>
                            <span>
                                您在注册成为夜樱情趣商城用户，并接受夜樱情趣商城服务时，您应该向夜樱情趣提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
                            </span>
                        </p>
                        <p>
                            <span>
                                您在注册夜樱情趣商城用户时生成的用于登陆夜樱情趣商城接收站内信、系统消息，也作为您的有效联系方式。
                            </span>
                        </p>
                        <p>
                            <span>
                                夜樱情趣将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。
                            </span>
                        </p>
                        <p>
                            <span>
                                您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；您如果不愿意接收此类信息，您有权通过夜樱情趣提供的相应的退订功能进行退订。
                            </span>
                        </p>
                        <p><strong><span>8.2 通知的送达</span></strong></p>
                        <p>
                            <span>
                                夜樱情趣通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在夜樱情趣商城公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
                            </span>
                        </p>
                        <p>
                            <span>
                                对于在夜樱情趣商城上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在夜樱情趣商城注册、更新时提供的手机号码、电子邮箱联系方式以及在注册夜樱情趣用户时生成账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。
                            </span>
                        </p>
                        <p>
                            <span>
                                您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。
                            </span>
                        </p>
                        <p>
                            <span>
                                您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。
                            </span>
                        </p>
                        <p>
                            <span>
                                你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
                            </span>
                            <br>
                        </p>
                        <p><strong><span>九、 协议的终止</span></strong></p>
                        <p><strong><span>9.1 终止的情形</span></strong></p>
                        <p>
                            <span>
                                【用户发起的终止】您有权通过以下任一方式终止本协议：
                            </span>
                        </p>
                        <p>
                            <span>
                                （一）在满足夜樱情趣商城公示的账户注销条件时您通过网站自助服务注销您的账户的；
                            </span>
                        </p>
                        <p>
                            <span>
                                （二）变更事项生效前您停止使用并明示不愿接受变更事项的；
                            </span>
                        </p>
                        <p>
                            <span>
                                （三）您明示不愿继续使用夜樱情趣商城服务，且符合夜樱情趣商城终止条件的。
                            </span>
                        </p>
                        <p>
                            <span>
                                【夜樱情趣发起的终止】出现以下情况时，夜樱情趣可以本协议第八条的所列的方式通知您终止本协议：
                            </span>
                        </p>
                        <p>
                            <span>
                                （一）您违反本协议约定，夜樱情趣依据违约条款终止本协议的；
                            </span>
                        </p>
                        <p>
                            <span>
                                （二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，夜樱情趣依据夜樱情趣商城规则对您的账户予以查封的；
                            </span>
                        </p>
                        <p>
                            <span>
                                （三）除上述情形外，因您多次违反夜樱情趣商城规则相关规定且情节严重，夜樱情趣依据夜樱情趣商城规则对您的账户予以查封的；
                            </span>
                        </p>
                        <p>
                            <span>
                                （四）您的账户被夜樱情趣依据本协议回收的；
                            </span>
                        </p>
                        <p>
                            <span>
                                （五）您在夜樱情趣有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；
                            </span>
                        </p>
                        <p><span>（六）其它应当终止服务的情况。</span></p>
                        <p><strong><span>9.2 协议终止后的处理</span></strong></p>
                        <p>
                            <span>
                                【用户信息披露】本协议终止后，除法律有明确规定外，夜樱情趣无义务向您或您指定的第三方披露您账户中的任何信息。
                            </span>
                        </p>
                        <p>
                            <span>
                                【夜樱情趣权利】本协议终止后，夜樱情趣仍享有下列权利：
                            </span>
                        </p>
                        <p>
                            <span>
                                （一）继续保存您留存于夜樱情趣商城的本协议第五条所列的各类信息；
                            </span>
                        </p>
                        <p>
                            <span>
                                （二）对于您过往的违约行为，夜樱情趣仍可依据本协议向您追究违约责任。
                            </span>
                        </p>
                        <p>
                            <span>
                                【交易处理】本协议终止后，对于您在本协议存续期间产生的交易订单，夜樱情趣可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
                            </span>
                        </p>
                        <p><strong><span>十、 法律适用、管辖与其他</span></strong></p>
                        <p>
                            <span>
                                【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
                            </span>
                        </p>
                        <p>
                            <span>
                                【管辖】您因使用夜樱情趣商城服务所产生及与夜樱情趣商城服务有关的争议，由夜樱情趣与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。
                            </span>
                        </p>
                        <p>
                            <span>
                                【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
                            </span>
                        </p>
                        <p style="text-align: right;">
                            <span>最新版本生效日期：2020年6月30日</span>
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/falvshengming" style="float:left;">上一篇:法律声明</a>
                        <a href="/help/yingyezhizhao" class="pl10" style="float:right">下一篇:营业执照</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/fuwuxieyi.vue